export const formateDollarAmount = (amount: number) => {
  if (Number.isNaN(amount)) return '$0.00';
  if (!amount || amount === null) return '$0.00';
  if (amount >= 0) return `$${amount?.toFixed(2)}`;

  return amount?.toFixed(2).replace('-', '-$');
};
